module.exports = __webpack_public_path__ + "img/fd-up-active.c97b72a4.png";